module.exports = __webpack_public_path__ + "static/media/communication.e1f61e21.png";